import { useState } from "react";
import { router } from "@inertiajs/react";
import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";

interface UseVerificationOptions {
  taskId?: number;
  onSuccess?: () => void;
}

export const useVerification = (options: UseVerificationOptions = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const verifyIdentity = async () => {
    setIsLoading(true);

    try {
      const response = await axios.post("/identity_verifications/verification", {
        identity_verification_task_id: options.taskId,
      });

      if (response.data.verify_url) {
        options.onSuccess?.();
        window.location.href = response.data.verify_url as string;
      } else {
        throw new Error("No verify_url received from verification service");
      }
    } catch (e) {
      // 409 = verification already finished; refresh in place — a hard reload wipes the banner's latched state.
      if (axios.isAxiosError(e) && e.response?.status === 409) {
        void queryClient.invalidateQueries({ queryKey: ["tasks"] });
        void queryClient.invalidateQueries({ queryKey: ["clear-verification-status"] });
        router.reload();
        return;
      }
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    verifyIdentity,
    isLoading,
  };
};
